/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyCGi4NlvkdUDtWhCKeUMcoETGKPPfsYjXU",
    authDomain: "angularux.firebaseapp.com",
    databaseURL: "https://angularux.firebaseio.com",
    projectId: "angularux",
    storageBucket: "angularux.appspot.com",
    messagingSenderId: "55819497125",
    appId: "1:55819497125:web:13957f1ec551bc8259274c",
    measurementId: "G-X1C5QW10R0"
  },
};
